import { createSlice } from '@reduxjs/toolkit';

// Auth slice. ВАЖНО: refresh-token больше НЕ хранится во фронте.
// Он живёт в httpOnly cookie (см. tokenService.js на бэке), невидим для
// JS, шлётся автоматически в /auth/refresh при `credentials: 'include'`.
// Это защищает от XSS-угона refresh'а — даже если кто-то впрыснет скрипт
// в приложение, токен прочитать нельзя.

const initialState = {
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  token: localStorage.getItem('accessToken') || null,
  // refreshToken НЕ читаем из localStorage — старый key мог остаться от
  // прошлой версии, чистим его на старте, чтобы не маячил.
  refreshToken: null,
};

// Чистим legacy-ключ refreshToken в localStorage (был до миграции на cookie).
try {
  if (localStorage.getItem('refreshToken')) {
    localStorage.removeItem('refreshToken');
  }
} catch { /* ignore */ }

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      // refreshToken игнорируем даже если бэкенд случайно прислал — он не нужен.
      const { user, accessToken } = action.payload || {};
      state.user = user || state.user;
      state.token = accessToken || state.token;
      state.refreshToken = null;

      if (user) localStorage.setItem('user', JSON.stringify(user));
      if (accessToken) localStorage.setItem('accessToken', accessToken);
    },
    logOut: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
    },
    // Частичный мердж в user — для апдейтов отдельных полей (avatarUrl, name)
    // без полного re-login. Дёргается из uploadAvatar / updateProfile mutations
    // после успешного ответа, чтобы шапка и другие селекторы сразу увидели
    // новое значение, а не ждали выхода/входа.
    updateUser: (state, action) => {
      if (!state.user) return;
      state.user = { ...state.user, ...(action.payload || {}) };
      try { localStorage.setItem('user', JSON.stringify(state.user)); } catch { /* ignore */ }
    },
  },
});

export const { setCredentials, logOut, updateUser } = authSlice.actions;
export default authSlice.reducer;
